// PRODUCTION environment (used by `ng build --configuration production`).
// Fill every __PLACEHOLDER__ before building (see ../README.md, "Fill the placeholders"),
// or run ../deploy/fill-env.sh with a filled-in .env file.
// Google Maps / Mapbox keys and the Stripe publishable key are NOT set here: the panel reads them
// from the server (Admin > Settings > Map Setting / payment settings).
export const environment = {
  IMAGE_URL: "https://rhero-bucket.s3.ap-south-1.amazonaws.com",
  API_URL: "https://api.roadsidehero.ca",
  HISTORY_URL: "https://history.roadsidehero.ca",
  SOCKET_URL: "https://socket.roadsidehero.ca",

  defaultLang: "en",
  production: true,
  firebaseConfig: {
    apiKey: "AIzaSyDvJhykzjP9JFHanJaykIWK5lWKhKXVKZs",
    authDomain: "r-hero-415805.firebaseapp.com",
    databaseURL: "https://r-hero-415805-default-rtdb.firebaseio.com",
    projectId: "r-hero-415805",
    storageBucket: "r-hero-415805.firebasestorage.app",
    messagingSenderId: "200614637206",
    appId: "1:200614637206:web:49feef3e2be333566adcb7",
    measurementId: "G-VL8ZXRWLLL"
  },

  additionalFeatured: [
    "FallbackTypesSelection", // Fallback Types Selection
    "AwardDriver", // Award Driver
    "ShowAdditionalDocumentFilter", // Show Additional Document Filter
    "DriverHourlyPlatformFee"
  ]
};
